window.o_global.links =
  window.o_global.links ||
  (function () {
    const extraParam = (function () {
      const DATA_EXTRA_PARAM = "data-extra-param";

      /**
 *
 *
 *
 */
      function _init() {
        window.o_util.event.delegate(
          document,
          "mousedown",
          ".js_hasExtraParam",
          function () {
            const url = this.getAttribute("href");
            const extraParam = this.getAttribute(DATA_EXTRA_PARAM);

            if (extraParam) {
              this.setAttribute("href", window.o_util.fragment.push(extraParam, url));
            }
          },
          { passive: true },
        );
      }

      return {
        init: _init,
      };
    })();
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    const masking = (function () {
      const CLASS_UB64E = "ub64e";
      const fnWrapper = {};

      fnWrapper.realClick = function (link) {
        link.click();
      };

      fnWrapper.replaceLink = function () {
        const _self = this;
        const children = _self.childNodes;
        const { attributes } = _self;
        const classes = _self
          .getAttribute("class")
          .split(" ")
          .filter(function (value) {
            return value.replace(/\s+/g, "").length !== 0;
          });
        const style = _self.getAttribute("style");
        const target = _self.getAttribute("data-target");
        const parent = _self.parentNode;
        const ub64d = window.atob(_self.getAttribute(`data-${CLASS_UB64E}`));
        const link = document.createElement("a");
        let i; /*                 */

        /*                            */
        for (let k = 0, { length } = classes; k < length; k++) {
          if (classes[k] !== CLASS_UB64E) {
            link.classList.add(classes[k]);
          }
        }

        /*        */
        link.setAttribute("href", ub64d);

        /*                                           */
        style && link.setAttribute("style", style);
        target && link.setAttribute("target", target);
        if (target && target !== "_self") {
          /*                                                                                        */
          link.setAttribute("rel", "noopener noreferrer");
        }

        /*                                           */
        for (i = 0; i < attributes.length; i++) {
          if (attributes[i].name.indexOf("data-") !== -1 && attributes[i].name !== "data-ub64e") {
            link.setAttribute(attributes[i].name, attributes[i].value);
          }
        }

        /*                  */
        /*                                                                                        */
        /*                                                                         */
        fnWrapper.moveChildren(_self, _self.childNodes, link);

        /**
 *
 *
 *
 *
 *
 *
 *
 */
        {
          function removeEventListener(element) {
            element.removeEventListener("touchmove", onTouchMove);
            element.removeEventListener("touchend", onTouchEnd);
          }

          function onTouchMove() {
            removeEventListener(this);
          }

          function onTouchEnd(e) {
            window.o_util.event.stop(e);
            removeEventListener(this);
            this.click();
          }

          link.addEventListener("touchmove", onTouchMove);
          link.addEventListener("touchend", onTouchEnd);
        }

        parent.replaceChild(link, _self);

        return link;
      };

      fnWrapper.getReal = function (link) {
        if (link.classList.contains(CLASS_UB64E)) {
          link = fnWrapper.replaceLink.call(link);
        }

        return link;
      };

      fnWrapper.moveChildren = function (from, children, to) {
        while (children.length > 0) {
          const child = from.removeChild(children[0]);
          to.appendChild(child);
        }
      };

      fnWrapper.init = function () {
        for (
          let i = 0, els = document.querySelectorAll(`.${CLASS_UB64E}`);
          i < els.length;
          i += 1
        ) {
          const e = els[i];

          /*                                                   */
          /*                                                           */
          /*                                                                     */
          if (e.children.length === 0) {
            const span = document.createElement("span");
            span.setAttribute("style", "all: unset;");
            fnWrapper.moveChildren(e, e.childNodes, span);
            e.appendChild(span);
          }
        }

        window.o_util.event.delegate(
          document,
          "touchstart",
          `.${CLASS_UB64E}`,
          function () {
            fnWrapper.replaceLink.call(this);
          },
          {
            capture: true,
            passive: true,
          },
        );

        window.o_util.event.delegate(
          document,
          "mouseover",
          `.${CLASS_UB64E}`,
          function () {
            fnWrapper.replaceLink.call(this);
          },
          { passive: true },
        );

        window.o_util.event.delegate(
          document,
          "ub64e",
          `.${CLASS_UB64E}, a`,
          function () {
            let _self = this;

            if (this.classList.contains(CLASS_UB64E)) {
              _self = fnWrapper.replaceLink.call(this);
            }

            window.o_global.links.masking.realClick(_self);
          },
          {
            passive: true,
          },
        );
      };

      return {
        init: fnWrapper.init,
        realClick: fnWrapper.realClick,
        getReal: fnWrapper.getReal,
      };
    })();

    window.o_global.eventLoader.onReady(1, function () {
      masking.init();
      extraParam.init();
    });

    return {
      extraParam,
      masking,
    };
  })();

export {};
